import React from "react";

export default function Problem() {
  const problems = [
    {
      title: "Data Fragmentation",
      description: "Claims data is delayed and siloed. Employers lack real-time visibility."
    },
    {
      title: "Low Member Engagement",
      description: "Employees don't understand or trust their benefits."
    },
    {
      title: "Catastrophic Claims Risk",
      description: "One claim can devastate reserves. Stop-loss is reactive."
    },
    {
      title: "Too Many Vendors",
      description: "HR teams juggle disjointed platforms and billing chaos."
    },
    {
      title: "Hard-to-Measure ROI",
      description: "Supplemental programs rarely show meaningful results."
    },
    {
      title: "Compliance Overload",
      description: "ERISA, HIPAA, ACA, and state rules create friction and risk."
    }
  ];

  return (
    <section className="bg-white py-20 px-6" id="problem">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Why Traditional Benefits Systems Are Broken
        </h2>
        
        <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-12">
          Self-insured employers face rising costs, low employee engagement, scattered vendors, and compliance challenges — all without clear ROI.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-left">
          {problems.map((problem, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg border border-gray-200 hover:shadow-md transition-shadow">
              <h3 className="text-xl font-semibold mb-2 text-gray-800">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 